


























import { Vue, Component, Prop } from 'vue-property-decorator';

import Icon from "../../../components/Icon/Icon.vue";
import { BreadcrumbStruct } from "../includes/types/MenuItem";

@Component({
  components: {
    Icon
  }
})
export default class BreadcrumbItem extends Vue {
  @Prop() breadcrumbItem!: BreadcrumbStruct
}
